import { Type } from '@angular/core';
import { QuestionType } from '@empathy/survey/base';

import { AIChatSettingsComponent } from '../components/question-settings/question-type-settings-components/ai-chat-settings/ai-chat-settings.component';
import { CarouselSettingsComponent } from '../components/question-settings/question-type-settings-components/carousel-settings/carousel-settings.component';
import { DropdownSettingsComponent } from '../components/question-settings/question-type-settings-components/dropdown-choice-settings/dropdown-settings.component';
import { EssaySettingsComponent } from '../components/question-settings/question-type-settings-components/essay-settings/essay-settings.component';
import { FileUploadSettingsComponent } from '../components/question-settings/question-type-settings-components/file-upload-settings/file-upload-settings.component';
import { HiddenQuestionSettingsComponent } from '../components/question-settings/question-type-settings-components/hidden-question-settings/hidden-question-settings.component';
import { InfoPageSettingsComponent } from '../components/question-settings/question-type-settings-components/info-page-settings/info-page-settings.component';
import { InputSettingsComponent } from '../components/question-settings/question-type-settings-components/input-settings/input-settings.component';
import { MultiChoiceSettingsComponent } from '../components/question-settings/question-type-settings-components/multi-choice-settings/multi-choice-settings.component';
import { RankingSettingsComponent } from '../components/question-settings/question-type-settings-components/ranking-settings/ranking-settings.component';
import { RatingSettingsComponent } from '../components/question-settings/question-type-settings-components/rating-settings/rating-settings.component';
import { SingleChoiceSettingsComponent } from '../components/question-settings/question-type-settings-components/single-choice-settings/single-choice-settings.component';

export const QuestionTypeSettingsComponent: Record<QuestionType, Type<any>> = {
  [QuestionType.SingleChoice]: SingleChoiceSettingsComponent,
  [QuestionType.MultiChoice]: MultiChoiceSettingsComponent,
  [QuestionType.Input]: InputSettingsComponent,
  [QuestionType.Carousel]: CarouselSettingsComponent,
  [QuestionType.CarouselMultiChoice]: MultiChoiceSettingsComponent,
  [QuestionType.CarouselRating]: RatingSettingsComponent,
  [QuestionType.Rating]: RatingSettingsComponent,
  [QuestionType.Dropdown]: DropdownSettingsComponent,
  [QuestionType.Essay]: EssaySettingsComponent,
  [QuestionType.Heatmap]: undefined,
  [QuestionType.InfoPage]: InfoPageSettingsComponent,
  [QuestionType.FileUpload]: FileUploadSettingsComponent,
  [QuestionType.Terminate]: undefined,
  [QuestionType.HiddenChoice]: HiddenQuestionSettingsComponent,
  [QuestionType.AIChat]: AIChatSettingsComponent,
  [QuestionType.NPS]: undefined,
  [QuestionType.Ranking]: RankingSettingsComponent,
  [QuestionType.RankSort]: RankingSettingsComponent
};
